import ProjectContext, { Ordering } from './ProjectsContext';
import { ProjectHeader } from './ProjectHeader';
import { ProjectsList } from './ProjectsList';
import React, { useState } from 'react';

export const ProjectsScreen: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [orderType, setOrderType] = useState<Ordering>('alphabetical');
  const [filterTag, setFilterTag] = useState<string>();
  return (
    <ProjectContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        orderType,
        setOrderType,
        filterTag,
        setFilterTag,
      }}
    >
      <ProjectHeader />
      <ProjectsList />
    </ProjectContext.Provider>
  );
};
